export var createEmptyPet = function (uuid, clientId) {
    return {
        uuid: uuid(),
        name: "",
        groomingNotes: "",
        notes: [],
        allergies: "",
        active: true,
        deceased: false,
        personalities: [],
        medicalHistory: {
            dentals: [],
            medicalConditions: [],
            vaccines: [],
        },
        image: "",
        clientId: clientId,
        deleted: false,
        destroyable: true,
        hasMedicalConditions: false,
        customQuestionResponses: [],
        positivePersonalitiesList: [],
        negativePersonalitiesList: [],
    };
};
export var PetCardAction;
(function (PetCardAction) {
    PetCardAction["editPetInformation"] = "info";
    PetCardAction["editVaccines"] = "editVaccines";
    PetCardAction["editMedical"] = "editMedical";
    PetCardAction["editDental"] = "editDental";
    PetCardAction["editVet"] = "editVet";
})(PetCardAction || (PetCardAction = {}));
;
